import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

//redux
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

//reducers
import orderReducer from './store/reducers/orderReducer';
import shopReducer from './store/reducers/shopReducer';
import authReducer from './store/reducers/authReducer';

const composeEnhancers = process.env.NODE_ENV==='development'?window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: null || compose;

const logger = store => {
    return next => {
        return action => {
            //console.log('[Middleware] Dispaching', action) 
            const result = next(action);
            //console.log('[Middleware] next state', store.getState()) 
            return result
        }
    }
}
const rootReducer = combineReducers ({
    orderReducer: orderReducer,
    shopReducer: shopReducer,
    authReducer: authReducer,
})
const store = createStore(rootReducer,composeEnhancers(applyMiddleware(logger, thunk)))

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
